import { AFFILIATE_PROGRAM_API } from 'modules/affiliate-program/api/affiliate-program-api'
import {
  AffiliateFilterInterface,
  AffiliateStatsInterface,
} from 'modules/affiliate-program/types/affiliate-program-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'

export function useAffiliateStatistic({ filter }: { filter: AffiliateFilterInterface }) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, AffiliateStatsInterface>({
    method: RequestMethodsEnum.get,
  })

  const filterApi = `${filter.dateSince ? `?filter[dateSince]=${filter.dateSince}` : ''}${
    filter.dateTill ? `&filter[dateTill]=${filter.dateTill}` : ''
  }`

  const { data: affiliateStatistic } = useSWR(() => {
    if (user && filter.dateSince !== null) {
      return `${AFFILIATE_PROGRAM_API}/index${filterApi}`
    }
    return null
  }, fetcher)

  return { affiliateStatistic }
}
